import { defaultSiteContent } from "../content/defaultContent";
import { adminApi, publicApi } from "./supabase";

const validPages = new Set(Object.keys(defaultSiteContent));

function validatePage(page) {
  if (!validPages.has(page)) throw new Error(`Unknown content page: ${page}`);
}

export async function fetchPageContent(page) {
  validatePage(page);
  const rows = await publicApi(
    `site_content?select=content&page_key=eq.${encodeURIComponent(page)}&limit=1`
  );
  return rows[0]?.content || defaultSiteContent[page];
}

export async function fetchAdminContent() {
  const rows = await adminApi("site_content?select=page_key,content,updated_at&order=page_key");
  return Object.fromEntries(rows.map((row) => [row.page_key, row.content]));
}

export async function savePageContent(page, content) {
  validatePage(page);
  const rows = await adminApi(`site_content?page_key=eq.${encodeURIComponent(page)}`, {
    method: "PATCH",
    headers: { Prefer: "return=representation" },
    body: JSON.stringify({ content }),
  });

  if (!rows[0]) throw new Error(`The ${page} content row could not be updated.`);
  return rows[0].content;
}
